import installSettings from './config/settings';
import installBlocks from './config/blocks';
import installSummaries from './config/summary';
import installViews from './config/views';
import installSlots from './config/slots';

import { personfunction, taxonomies, sponsors } from './reducers';

const applyConfig = (config) => {
  installSettings(config);
  installBlocks(config);
  installSummaries(config);
  installSlots(config);
  installViews(config);

  config.addonReducers.personfunction = personfunction;
  config.addonReducers.taxonomies = taxonomies;
  config.addonReducers.sponsors = sponsors;
  // console.log('config in volto-saw-homepage', config);
  return config;
};

export default applyConfig;
